import { render, staticRenderFns } from "./ExcFullLogo.vue?vue&type=template&id=1742df33&scoped=true&"
import script from "./ExcFullLogo.vue?vue&type=script&lang=ts&"
export * from "./ExcFullLogo.vue?vue&type=script&lang=ts&"
import style0 from "./ExcFullLogo.vue?vue&type=style&index=0&id=1742df33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1742df33",
  null
  
)

export default component.exports